"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEDIA_SPACING = exports.MEDIA_ALIGNMENT_TYPES = void 0;
var MEDIA_ALIGNMENT_TYPES = {
  start: 'private-media--align-start',
  baseline: 'private-media--align-baseline',
  center: 'private-media--align-middle',
  end: 'private-media--align-bottom',
  stretch: 'private-media--align-stretch'
};
exports.MEDIA_ALIGNMENT_TYPES = MEDIA_ALIGNMENT_TYPES;
var MEDIA_SPACING = {
  none: 'private-media--collapsed',
  'extra-small': 'private-media--spaced-xs',
  small: '',
  medium: 'private-media--spaced-md',
  large: 'private-media--spaced-lg',
  'extra-large': 'private-media--spaced-xl'
};
exports.MEDIA_SPACING = MEDIA_SPACING;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/layout/MediaConstants.js
// module id = 749
// module chunks = 209 210 211 212